<template>
  <div>
    {{ titleTotal || 'Tổng số:' }}
    <strong class="text-primary"
      ><span v-if="totals">{{ totals | formatNumber }}</span
      ><span v-else>0</span></strong
    >
    <span v-if="data.length > 0">
      &nbsp;&nbsp;|&nbsp;&nbsp;
      <span v-for="(item, index) in data" :key="item.status">
        {{ item.status }}:
        <strong :class="item.status_class">{{
          item.count | formatNumber
        }}</strong>
        <span v-if="index < data.length - 1">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
      </span>
    </span>
  </div>
</template>
<script>
export default {
  props: ['totals', 'data', 'titleTotal'],
  filters: {
    formatNumber(value) {
      if (!value) return 0
      // return new Intl.NumberFormat('vi-VN').format(value);
      return value.toLocaleString('vi-VN')
    }
  }
}
</script>
